import React from 'react';
import PropTypes from 'prop-types';

import LanguageFooter from '../../common/LanguageFooter';
import NavbarStandard from '../../common/navbar/NavbarStandard';

function Page({ children, unfixed, footer }) {
  return (
    <>
      <NavbarStandard unfixed={unfixed} />
      {children}
      {footer
      && <LanguageFooter />}
    </>
  );
}

Page.propTypes = {
  unfixed: PropTypes.bool,
  children: PropTypes.node,
  footer: PropTypes.bool,
};

Page.defaultProps = {
  unfixed: true,
  children: null,
  footer: true,
};

export default Page;
